import { Fragment } from "react";
import "./SmartDevelopment.css";
import { smartDevelopment } from "../../staticdata";
import smartcontractbanner from "../../assets/images/services/blockchain/smartcontract.jpg";

const SmartDevelopment = () => {
  return (
    <Fragment>
      <section className="smartcontract-style">
        <div className="smartcontract-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="smartcontract-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Smart Contract Development
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Improve and streamline your business processes using our
                  meticulously designed smart contract development solutions
                  tailored for enterprises in different industries. Kairaa, as a
                  smart contract development company, effectively automates your
                  business agreements that typically involve manual transactions
                  between multiple parties.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={smartcontractbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="smartcontract-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our <span className="title-gradient">Smart Contract Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {smartDevelopment.map((services, index) => (
                <div className="col-lg-4 col-md-6" key={services.id} data-aos="zoom-in">
                  <div className="smartcontract-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default SmartDevelopment;
